export default __webpack_public_path__ + "static/media/006-butterflies.7942cb87.svg";